"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const viewportConfig_1 = __importDefault(require("./viewportConfig"));
const { midResolutionHeight, lowResolutionWidth, preferredAppWidth, framedModeMinMargin, maxAppHeight, } = viewportConfig_1.default.viewport;
const useMediaQuery = (query) => {
    const mediaQuery = window.matchMedia(query);
    let matches = mediaQuery.matches;
    const handleMediaQueryChange = (event) => {
        matches = event.matches;
    };
    const mediaQueryListener = (mediaQuery) => {
        mediaQuery.addEventListener('change', handleMediaQueryChange);
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    };
    const cleanup = mediaQueryListener(mediaQuery);
    window.addEventListener('resize', cleanup);
    return matches;
};
const useStyles = () => {
    const easeTransition = 'height 0.5s ease';
    const isNarrowScreen = useMediaQuery(`(max-width: ${lowResolutionWidth}px)`);
    const isMidResolutionHeight = useMediaQuery(`(min-height: ${midResolutionHeight}px)`);
    const width = isNarrowScreen ? '100%' : `${preferredAppWidth}px`;
    const height = isNarrowScreen
        ? '100%'
        : isMidResolutionHeight
            ? '70%'
            : `calc(100% - ${framedModeMinMargin}px)`;
    const isPortraitOrientation = useMediaQuery('(orientation: portrait)');
    const maxHeight = isNarrowScreen && isPortraitOrientation ? undefined : maxAppHeight;
    return {
        width,
        height,
        maxHeight: maxHeight ? `${maxHeight}px` : undefined,
        borderRadius: isNarrowScreen ? '0px' : '16px',
        transition: easeTransition,
    };
};
exports.useStyles = useStyles;
